import { Component, OnInit } from '@angular/core';
import { TerminalsApiService } from '../../services/terminals-api.service';

@Component({
  selector: 'app-terminals',
  templateUrl: './terminals.component.html',
  styleUrls: ['./terminals.component.scss']
})

export class TerminalsComponent implements OnInit {

  constructor(
    public terminalsApiService: TerminalsApiService
  ) { }

  ngOnInit() {

  }

}
